'use client';

import { useTranslations } from 'next-intl';

export function ContactContent() {
  const t = useTranslations('contact');

  return (
    <div className="mb-8 text-center">
      <h1 className="text-3xl font-bold tracking-tight text-white">{t('title')}</h1>
      <p className="mt-3 text-white/60">{t('subtitle')}</p>
    </div>
  );
}
